/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useTheme } from '@material-ui/core';
import { Star } from './Star';

export const AuthenticityRating = ({ numStars }) => {
  const theme = useTheme();

  return (
    <div
      css={css`
        display: flex;
        justify-content: flex-end;
      `}
    >
      <a
        href="/certificate/andy-warhol-deborah-harry-original-nft"
        css={css`
          color: #ededed;
          font-family: Montserrat;
          font-weight: 500;
          text-decoration: none;
          cursor: pointer;
          font-size: 12px;
          letter-spacing: 0.09px;
          line-height: 15px;
          display: flex;
          align-items: center;
          ${theme.breakpoints.up('sm')} {
            font-size: 18px;
            letter-spacing: 0.14px;
            line-height: 22px;
          }
          &:hover {
            text-decoration: underline;
          }
        `}
      >
        NFT Authenticity Rating
        <Star
          css={css`
            margin-left: 5px;
            ${theme.breakpoints.up('sm')} {
              margin-left: 10px;
            }
          `}
        />
        <Star />
        <Star />
        <Star />
        <Star />
      </a>
    </div>
  );
};
